module.exports = __webpack_public_path__ + "img/MSTART-menu.1911d3fe.jpg";